import { useQuery } from "@tanstack/react-query";

import { api, MaritimeWarning } from "@/lib/api";

import { parseLastPublishedAtFromHeader } from "./parse-maritime-last-published-at";

export type { MaritimeWarning };
export type { MaritimeArea, MaritimeWarningDomainId } from "./maritime-areas.queries";
export { maritimeAreasQuery, useMaritimeAreasQuery } from "./maritime-areas.queries";

export type MaritimeWarningsResponse = {
  warnings: MaritimeWarning[];
  /**
   * Publication time of the current warnings dataset (ISO 8601).
   * Derived from the HTTP Last-Modified response header when present and valid.
   * @see parseLastPublishedAtFromHeader
   */
  lastPublishedAt?: string;
};

const maritimeWarningKeys = {
  warnings: ["maritimeWarnings", "warnings"] as const,
};

async function fetchMaritimeWarnings(): Promise<MaritimeWarningsResponse> {
  const { data, headers } = await api.data.listMaritimeWarnings();

  return {
    warnings: data ?? [],
    lastPublishedAt: parseLastPublishedAtFromHeader(headers["last-modified"]),
  };
}

const maritimeWarningsQuery = () =>
  ({
    queryKey: maritimeWarningKeys.warnings,
    queryFn: fetchMaritimeWarnings,
  }) as const;

export const selectMaritimeWarnings = (data: MaritimeWarningsResponse | undefined) =>
  data?.warnings ?? [];

export const useMaritimeWarningsQuery = (options?: { enabled?: boolean }) =>
  useQuery({
    ...maritimeWarningsQuery(),
    enabled: options?.enabled ?? true,
  });
